import React, { FC } from 'react'
import { useController } from 'react-hook-form'
import { Input } from '@wmgtech/legato'

import { FormInputProps } from './FormInput.props'
import './FormInput.scss'

const FormInput: FC<FormInputProps> = ({
  suffixIcon,
  control,
  fieldName,
  rules,
  dataTest,
  disabled,
  placeholder,
  className,
  warning,
  autoComplete = 'off',
  size = 'md'
}) => {
  const {
    field,
    fieldState: { error }
  } = useController({
    name: fieldName,
    control,
    rules
  })

  return (
    <Input
      size={size}
      className={className}
      data-test={dataTest}
      placeholder={placeholder}
      disabled={disabled}
      suffixIcon={suffixIcon}
      autoComplete={autoComplete}
      crossOrigin
      {...field}
      validation={
        warning?.isShow && !error
          ? { message: warning?.message, type: 'warning' }
          : {
            message: error?.message,
            ...(error && { type: 'error' })
          }
      }
    />
  )
}

export default FormInput
